import railsToMomentFormat from './railsToMomentFormat'
import momentToFlatpickrFormat from './momentToFlatpickrFormat'

export default (dateFormat) => {
  const momentFormat = railsToMomentFormat(dateFormat)
  return momentToFlatpickrFormat(momentFormat)
}
